import React from 'react';
import {
  Grid,
  Select,
  Typography,
} from '@material-ui/core';

import classes from '../../css/getCSS';


const selectBoxes = (props) => {
  let options = null;
  let fromConfig = {
    name: null,
    id: null,
  };
  let toConfig = {
    name: null,
    id: null,
  };
  if (props.facet === 'age') {
    const ageOptions = {};
    for (let index = 19; index < 61; index += 1) {
      ageOptions[index] = index;
    }
    options = ageOptions;
    fromConfig = {
      name: 'From age',
      id: 'from_age',
    };
    toConfig = {
      name: 'To age',
      id: 'to_age',
    };
  } else {
    const heightOptions = {};
    for (let i = 4; i <= 6; i += 1) {
      for (let j = 0; j <= 11; j += 1) {
        const ft = i;
        let inch = j;
        inch += (ft * 12);
        const cm = inch * 2.54;
        heightOptions[parseInt(cm, 10)] = `${i}ft ${j}in`;
      }
    }
    options = heightOptions;
    fromConfig = {
      name: 'From height',
      id: 'from_height',
    };
    toConfig = {
      name: 'To height',
      id: 'to_height',
    };
  }

  let fromValue = null;
  let toValue = null;
  const valueF = props.activeFilters.filter(val => val.name === fromConfig.id);
  if (valueF.length > 0) {
    fromValue = valueF[0].value;
  }
  const valueT = props.activeFilters.filter(val => val.name === toConfig.id);
  if (valueT.length > 0) {
    toValue = valueT[0].value;
  }

  return (
    <Grid container>
      <Grid item md={6} sm={6} xs={6} className={classes.padding10}>
        <Typography>From</Typography>
        <Select
          native
          fullWidth
          value={fromValue || ''}
          onChange={e => props.selectSingle(fromConfig.id, e.target.value)}
          className={[classes.textField, classes.selectField].join(' ')}
          inputProps={{
            name: fromConfig.name,
            id: fromConfig.id,
          }}
        >
          <option value="">{fromConfig.name}</option>
          {
            Object.keys(options).map((key) => {
              return <option key={key} value={key}>{options[key]}</option>;
            })
          }
        </Select>
      </Grid>
      <Grid item md={6} sm={6} xs={6} className={classes.padding10}>
        <Typography>To</Typography>
        <Select
          native
          fullWidth
          value={toValue || ''}
          onChange={e => props.selectSingle(toConfig.id, e.target.value)}
          className={[classes.textField, classes.selectField].join(' ')}
          inputProps={{
            name: toConfig.name,
            id: toConfig.id,
          }}
        >
          <option value="">{toConfig.name}</option>
          {
            Object.keys(options).map((key) => {
              return <option key={key} value={key}>{options[key]}</option>;
            })
          }
        </Select>
      </Grid>
    </Grid>
  );
};

export default selectBoxes;



// WEBPACK FOOTER //
// ./src/search/components/SelectBoxes.js